<script setup lang="ts">
import BoLetterHead from './parts/BoLetterHead.vue';
import BoLetterClose from './parts/BoLetterClose.vue';
</script>

<template>
  <div class="bo-doc">
    <BoLetterHead recipient-mode="registered_bo" />
    <p class="doc-p">
      Pursuant to subsection 60C(5) of the CA 2016, we have reasonable grounds to believe that a change has occurred
      to the particulars of your beneficial ownership information stated in the register of beneficial owners. Please
      confirm whether or not such change has occurred within 30 days from the date of this notice.
    </p>
    <p class="doc-p">
      <b>2</b><br />
      If the change has occurred, please state the date of the change and provide the particulars of the change.
    </p>
    <p class="doc-p"><b>3</b><br />Please include the following declaration as part of your reply:</p>
    <p class="doc-p" style="padding-left:16px; font-style:italic">
      “I/We hereby confirmed that the facts and information stated in this letter are true and to the best of my/our knowledge and belief.”
    </p>
    <p class="doc-p">
      <b>4</b><br />
      Please be informed that any person who fails to comply with this notice commits an offence under subsection
      60C(7) of the CA 2016 and/or provides false or misleading information commits an offence under section 593 of
      the CA 2016.
    </p>
    <BoLetterClose var-key="BO05" designation-key="signer_designation_BO05" />
  </div>
</template>

<style src="./boNoticeDoc.css"></style>
